export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-lottery-rain/index.js